import { createFileRoute, Link, redirect } from "@tanstack/react-router";

/**
 * Legacy English Turkish-section URLs -> localized Turkish slugs.
 * Keys are the splat (path after `/tr/`), values the new full path.
 */
const LEGACY: Array<[RegExp, (m: RegExpMatchArray) => string]> = [
  [/^services\/ams\/sap-managed-services\/?$/, () => "/tr/hizmetler/ams/sap-yonetilen-hizmetler"],
  [/^services\/ams\/what-is-sap-ams\/?$/, () => "/tr/hizmetler/ams/sap-ams-nedir"],
  [/^services\/technology-consulting\/?$/, () => "/tr/hizmetler/teknoloji-danismanligi"],
  [/^services\/ams\/?$/, () => "/tr/hizmetler/ams"],
  [/^services\/?$/, () => "/tr/hizmetler"],
  [/^solutions\/legal-tools\/?$/, () => "/tr/cozumler/yasal-uyum-araclari"],
  [/^solutions\/e-invoice\/?$/, () => "/tr/cozumler/sap-e-fatura-cozumu"],
  [/^solutions\/turkiye-e-fatura\/?$/, () => "/tr/cozumler/turkiye-e-fatura"],
  [/^solutions\/e-fatura\/?$/, () => "/tr/cozumler/almanya-e-fatura"],
  [/^solutions\/ai-devgui\/?$/, () => "/tr/cozumler/ai-devgui"],
  [/^solutions\/ai-idocmon\/?$/, () => "/tr/cozumler/ai-idocmon"],
  [/^solutions\/?$/, () => "/tr/cozumler"],
  [/^market-technology-trends(?:\/(.+?))?\/?$/, (m) => `/tr/pazar-teknoloji-trendleri${m[1] ? `/${m[1]}` : ""}`],
  [/^case-studies(?:\/(.+?))?\/?$/, (m) => `/tr/vaka-calismalari${m[1] ? `/${m[1]}` : ""}`],
  [/^whitepapers(?:\/(.+?))?\/?$/, (m) => `/tr/teknik-raporlar${m[1] ? `/${m[1]}` : ""}`],
  [/^articles(?:\/(.+?))?\/?$/, (m) => `/tr/makaleler${m[1] ? `/${m[1]}` : ""}`],
  [/^news(?:\/(.+?))?\/?$/, (m) => `/tr/haberler${m[1] ? `/${m[1]}` : ""}`],
  [/^FAQ-SSS(?:\/(.+?))?\/?$/i, (m) => `/tr/sss${m[1] ? `/${m[1]}` : ""}`],
  [/^media-inquiries\/?$/, () => "/tr/basin-talepleri"],
  [/^for-specialists\/?$/, () => "/tr/uzmanlar-icin"],
  [/^references\/?$/, () => "/tr/referanslar"],
  [/^directory\/?$/, () => "/tr/dizin"],
  [/^privacy\/?$/, () => "/tr/gizlilik"],
  [/^contact\/?$/, () => "/tr/iletisim"],
  [/^search\/?$/, () => "/tr/arama"],
  [/^about\/?$/, () => "/tr/hakkimizda"],
  [/^press\/?$/, () => "/tr/basin"],
  [/^legal\/?$/, () => "/tr/kunye"],
  [/^shoring\/?$/, () => "/tr/nearshore"],
];

function targetFor(splat: string): string | null {
  const clean = splat.replace(/^\/+/, "");
  for (const [pattern, build] of LEGACY) {
    const match = clean.match(pattern);
    if (match) return build(match);
  }
  return null;
}

export const Route = createFileRoute("/tr/$")({
  beforeLoad: ({ params }) => {
    const target = targetFor(params._splat ?? "");
    if (target) throw redirect({ href: target, statusCode: 301 });
  },
  head: () => ({
    meta: [
      { title: "Sayfa bulunamadı — OXORY" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
      {
        name: "description",
        content: "Bu sayfa mevcut değil. OXORY ana sayfasına dönebilirsiniz.",
      },
    ],
  }),
  component: TrNotFound,
});

function TrNotFound() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-background px-4 py-24">
      <div className="max-w-md text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          Hata 404
        </p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-foreground">Sayfa bulunamadı</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/tr"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Ana sayfa
          </Link>
          <Link
            to="/tr/iletisim"
            className="inline-flex items-center justify-center rounded-md border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted"
          >
            İletişim
          </Link>
        </div>
      </div>
    </div>
  );
}
